module.exports = "/_next/static/images/ico-fav-blue-99f83ec06bd9c4a923d4bab418f43f3f.svg";